export enum ApiRequestStartActionTypes {
    REQUEST = '@@application/api-request-start/request',
    SUCCESS = '@@application/api-request-start/success',
    ERROR = '@@application/api-request-start/error'
}

export enum ApiRequestEndActionTypes {
    REQUEST = '@@application/api-request-end/request',
    SUCCESS = '@@application/api-request-end/success',
    ERROR = '@@application/api-request-end/error'
}

export enum GetDashboardActionTypes {
    REQUEST = '@@application/get-dashboard/request',
    SUCCESS = '@@application/get-dashboard/success',
    ERROR = '@@application/get-dashboard/error'
}
